<template>
  <div class="animated fadeIn">
    <default-heading text="Share Results" class="mt-3">
      <template #right>
        <b-button
          variant="primary"
          class="ml-1"
          to="/results-sharing"
        >
          <i class="fal fa-list" />
        </b-button>
      </template>
    </default-heading>

    <div class="mb-3">
      <b-alert variant="info" show>
        <i class="fa fa-info-circle" />
        Shared results are made available to other customers. Results can be shared for entire sample types, date ranges, crop types, etc. 
        To share results you will need to obtain the other user's 'DTE Customer Number'. To do so you will need to contact either DTE
        or the user you are trying to share data with.
      </b-alert>
      <ResultSharingForm :submittingForm="submittingForm" :error="error" @submit="submit" />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import ResultSharingForm from '@/components/results/resultsharing/ResultSharingForm'
import ResultSharingModel from '@/models/result/ResultSharingModel'

export default {
  name: 'ResultSharingAdd',
  components: {
    DefaultHeading,
    ResultSharingForm
  },
  data () {
    return {
      error: null,
      submittingForm: false
    }
  },
  methods: {
    async submit (form_data) {
      this.error = null
      this.submittingForm = true

      try {
        const resultSharingModel = new ResultSharingModel({
          ...form_data
        })

        const { response } = await resultSharingModel.save()
        
        this.$bvToast.toast('Results Shared', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 1000
        })
        this.$router.push('/results-sharing')
      } catch (err) {
        if (err.response && err.response.response && err.response.response.data && err.response.response.data.message) {
          this.error = err.response.response.data.message
        } else {
          this.error = err.err || 'Something went wrong please contact an administrator'
        }
      }

      this.submittingForm = false
    }
  }
}
</script>
